export const gradient = Object.freeze({
  Dusty_Grass: "120deg, #d4fc79 0%, #96e6a1 100%",
  Sand_to_Blue: "to right, #DECBA4, #3E5151",
  Relaxing_Red: "to right, #fffbd5, #b20a2c",
  Sublime_Light: "to right, #fc5c7d, #6a82fb",
  Megatron: "to right, #c6ffdd, #fbd786, #f7797d",
  Premium_Dark: "to right, #434343 0%, black 100%",
  Lawrencium: "to right, #0f0c29, #302b63, #24243e",
  The_Strain: "to right, #870000, #190a05",
  Cherry_Blossom: "25deg,#d64c7f,#ee4758 50%",
  Noon_to_Dusk: "to right, #ff6e7f, #bfe9ff",
  Forest: "to right, #5a3f37, #2c7744",
  Royal: "to right, #141e30, #243b55",
});

export const scoreboard = Object.freeze({
  1: {
    background: "292826",
    color: "F9D342",
  },
  2: {
    background: "3C1A5B",
    color: "FFF748",
  },
  3: {
    background: "1D1B1B",
    color: "EC4D37",
  },
  4: {
    background: "243665",
    color: "8BD8BD",
  },
  5: {
    background: "161B21",
    color: "F4A950",
  },
  6: {
    background: "262223",
    color: "DDC6B6",
  },
  7: {
    background: "191919",
    color: "B88746",
  },
  8: {
    background: "050505",
    color: "E6E7E8 ",
  },
  9: {
    background: "072C50",
    color: "FDF5A6",
  },
});

export const cardsPattern = Object.freeze({
  one: "Buntings",
  two: "Misty Fence",
  three: "Evil Eye Charm",
  four: "Mountain Range",
  five: "Plain Old Kurti",
  six: "Jets of cloud",
  seven: "Chocolate Diamonds",
  eight: "Waffles",
  nine: "Black Bookmarks",
  ten: "More Buntings",
  eleven: "Table Cloth",
  twelve: "Dark Void",
});

export const avatars = Object.freeze([
  "m1",
  "m2",
  "m3",
  "m4",
  "g1",
  "g2",
  "g3",
  "g4",
]);
